import { GlButton, GlCollapsibleListbox, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { InternalEvents } from '../../tracking/index.js?vue3';
import { SIDEBAR_NAV_MODE_COMPACT, SIDEBAR_NAV_MODE_FULL } from '../constants';
import { EVENT_SELECT_SIDEBAR_NAVIGATION_MODE_IN_SIDEBAR_PREFERENCES } from '../tracking_constants';
// Ordered least to most expansive.
const ITEMS = [
    {
        value: SIDEBAR_NAV_MODE_COMPACT,
        text: s__('Navigation|Compact'),
        description: s__('Navigation|Pinned only')
    },
    {
        value: SIDEBAR_NAV_MODE_FULL,
        text: s__('Navigation|Full'),
        description: s__('Navigation|Pinned and all categories')
    }
];
export default {
    name: 'SidebarPreferences',
    components: {
        GlButton,
        GlCollapsibleListbox
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        InternalEvents.mixin()
    ],
    inject: {
        panelType: {
            default: ''
        }
    },
    props: {
        mode: {
            type: String,
            required: false,
            default: SIDEBAR_NAV_MODE_COMPACT
        }
    },
    emits: [
        'select'
    ],
    i18n: {
        customizeSidebar: s__('Navigation|Customize sidebar')
    },
    items: ITEMS,
    methods: {
        onSelect (mode) {
            if (mode === this.mode) return;
            // A single event carries the chosen mode as `property` so each option can
            // be counted directly, rather than inferred from on/off toggle pairs.
            this.trackEvent(EVENT_SELECT_SIDEBAR_NAVIGATION_MODE_IN_SIDEBAR_PREFERENCES, {
                label: this.panelType,
                property: mode
            });
            this.$emit('select', mode);
        }
    }
};
